// Helper to normalize OS name for Mixpanel
export const normalizeOsName = (osName?: string): string => {
  if (!osName) return "";
  if (osName === "macOS") return "Mac OS X";
  return osName;
};
